import { observer } from "mobx-react-lite";
import { useContext } from "react";

import { MessageBar, MessageBarType } from "@bps/fluent-ui";

import { StatementItemsContext } from "../context/StatementItemsContext.ts";

export const StatementBulkInfo = observer(() => {
  const { selectedIds, emailedStatementsNumber, numberOfPrinted } = useContext(
    StatementItemsContext
  );

  if (selectedIds?.length === 0) {
    return null;
  }

  return (
    <MessageBar
      messageBarType={MessageBarType.warning}
      messageBarIconProps={{ iconName: "Info" }}
    >
      <span>
        {emailedStatementsNumber > 0 &&
          `${emailedStatementsNumber} will be emailed`}
        {emailedStatementsNumber > 0 && numberOfPrinted > 0 && ", "}
        {numberOfPrinted > 0 && `${numberOfPrinted} available to print`}
      </span>
    </MessageBar>
  );
});
